export type OcFormElement = HTMLElement & {
  validationMessage?: string;
  hint?: string;
  hideDetails: boolean;
};
export const isControllableElement = (node: Node): node is OcFormElement =>
  node instanceof HTMLElement && node.tagName.startsWith("OC-");
